import type { Language } from '@inflearn/i18n-tools';
import type { GetServerSidePropsContext } from 'next';
import { useTranslation } from 'next-i18next';
import type { ReactElement } from 'react';
import PartnersPolicyLayout from '../../../components/layout/PolicyLayout/partners';
import { PolicyContent } from '../../../components/pages/policy/PolicyContent';
import { getCdnTranslationProps } from '../../../utils/server/i18n/getCdnTranslationProps';

export const getServerSideProps = async (context: GetServerSidePropsContext) => {
  const locale = context.locale as Language;
  const isWebview = context.query.type === 'app';

  return {
    props: {
      isWebview: isWebview,
      ...(await getCdnTranslationProps(locale, ['common'])),
    },
  };
};

export default function PartnersGuidePage({
  isWebview,
}: {
  isWebview: boolean;
}) {
  const { t } = useTranslation();

  return (
    <PolicyContent
      title={t('파트너스 가이드')}
      type="MARKETING_PARTNERS_GUIDE"
      period="CURRENT"
      isWebview={isWebview}
    />
  );
}

PartnersGuidePage.getLayout = (page: ReactElement) => (
  <PartnersPolicyLayout
    meta={{
      title: '파트너스 가이드',
      description: '메타.파트너스가이드.설명',
    }}
  >
    {page}
  </PartnersPolicyLayout>
);
